const initialState = {
  allSubscriptions: [],
  filteredSubscriptions: null,
  loading: true,
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_SUBSCRIPTION":
      return {
        ...state,
        allSubscriptions: action.data,
        loading: action.loading,
      };

    case "GET_FILTERED_SUBSCRIPTION":
      return {
        ...state,
        allSubscriptions: action.data,
        loading: action.loading,
      };

    case "LOADING_DATA": {
      return { ...state, loading: true };
    }
    default:
      return state;
  }
};

export default subscriptionReducer;
